import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, CheckSquare, Contact, MoreHorizontal, Sparkles } from "lucide-react";
import { useState } from "react";
import MobileMoreSheet from "@/app/MobileMoreSheet";

const TABS = [
  { to: "/app", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/app?ai=1", label: "AI", icon: Sparkles, event: "ai" },
  { to: "/app/work", label: "Work", icon: CheckSquare },
  { to: "/app/sales", label: "Sales", icon: Contact },
];

export default function MobileTabBar() {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <nav
        className="fixed inset-x-0 bottom-0 z-30 flex items-stretch border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
        data-testid="mobile-tab-bar"
        aria-label="Primary"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`mobile-tab-${t.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${
                isActive ? "text-brand-teal" : "text-muted-foreground"
              }`
            }
            onClick={(e) => {
              if (t.event === "ai") {
                e.preventDefault();
                navigate("/app");
                setTimeout(() => window.dispatchEvent(new CustomEvent("stupeco:open-ai-chat")), 30);
              }
            }}
          >
            <t.icon className="h-5 w-5" />
            {t.label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={() => setMoreOpen(true)}
          data-testid="mobile-tab-more"
          className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium text-muted-foreground"
        >
          <MoreHorizontal className="h-5 w-5" />
          More
        </button>
      </nav>
      <MobileMoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
    </>
  );
}
